module.exports = __webpack_public_path__ + "jimmy-5f657c49a2d499fec5aef83204b58417.webp";